import React from 'react'
import { Container } from 'react-bootstrap';

const Footer = () => {
  return (
    <div className='footer mt-4'>
      <Container>
        	<h4>Important Links</h4>
          <h6><a href="https://www.cbic.gov.in/" title="CBIC" target="_blank">CBIC</a> | <a href="https://www.dgft.gov.in/CP/" title="DGFT" target="_blank">DGFT</a></h6>

          <div className="ft-bottom">
            <span id="date_time"></span>
            <script type="text/javascript">window.onload = date_time('date_time');</script>
            <br/>
            <span>© {new Date().getFullYear()} - {new Date().getFullYear() + 1} | All Rights Reserved. </span>
          </div>
      </Container>
    </div>
  )
}
export default Footer
